import apiClient from './apiClient';

const client = apiClient('promos/blockchain');

const blockchainApi = {
    getConfig: () => client.get('/config'),
    getDashboard: () => client.get('/dashboard'),
    getPromoBlockchainInfo: (promoId) => client.get(`/${promoId}`),
    signClaim: (data) => client.post('/sign-claim', data),
    getClaims: (page = 1, limit = 50) => client.get(`/claims?page=${page}&limit=${limit}`),
    syncFunded: () => client.post('/sync-funded'),
    getDeposits: (page = 1, limit = 50) => client.get(`/deposits?page=${page}&limit=${limit}`),

    // ── Админские on-chain действия (бэкенд шлёт их ключом operator) ──
    // Каждое отправляет транзакцию в сеть и тратит газ operator-кошелька.
    /** Аварийный стоп: замораживает ВСЕ депозиты и клеймы платформы. */
    adminPause: () => client.post('/admin/pause'),
    /** Снять аварийный стоп. */
    adminUnpause: () => client.post('/admin/unpause'),
    /** Заморозить/разморозить одно промо. У замороженного: клеймы стоят И промоутер
     *  НЕ может забрать остаток — деньги ждут решения админа. */
    adminSetPromoActive: (promoId, active) =>
        client.post('/admin/promo-active', { promoId, active }),
    /** Окно после конца промо, пока победители ещё могут клеймить (в секундах). */
    adminSetGracePeriod: (seconds) => client.post('/admin/grace-period', { seconds }),
};

export default blockchainApi;
